var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { attrs: { id: "list-tasks" } }, [
    _c("li", [
      !_vm.mobileView
        ? _c("div", { staticClass: "oblea" }, [
            _c(
              "div",
              {
                staticClass: "fh lc",
                staticStyle: { width: "100%", height: "25%" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: {
                      width: "75%",
                      height: "100%",
                      "font-weight": "500",
                      "font-size": "15px",
                      color: "#5c666f",
                      "margin-left": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "\n                 Dev: " +
                        _vm._s(_vm.item.Numero) +
                        "\n              "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh rc",
                    staticStyle: {
                      width: "25%",
                      height: "100%",
                      "margin-right": "10px"
                    },
                    on: { click: _vm.btnVer }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "15px", height: "15px" },
                      attrs: { id: "iconoVer", src: "/dist/icon-ver.png" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "font-size": "11px",
                          "margin-left": "5px",
                          color: "#5c666f"
                        }
                      },
                      [_vm._v("VER")]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh lt",
                staticStyle: {
                  width: "100%",
                  height: "15%",
                  "margin-left": "10px",
                  "margin-right": "10px",
                  "font-weight": "400",
                  "font-size": "9px",
                  color: "#5c666f"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: { width: "77%", height: "100%" }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("filterFecha")(_vm.item.Fecha)) + " "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: { width: "20%", height: "100%" }
                  },
                  [_c("div", { attrs: { id: "circulo" + _vm.item.Estado } })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh lc",
                staticStyle: { width: "100%", height: "30%" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: {
                      width: "75%",
                      height: "100%",
                      "font-weight": "500",
                      "font-size": "16px",
                      color: "#4969B2",
                      "margin-left": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "\n                  $" +
                        _vm._s(_vm._f("formatMoney")(_vm.item.MontoTotal)) +
                        " \n              "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh rc",
                    staticStyle: {
                      width: "25%",
                      height: "100%",
                      "font-size": "11px",
                      color: "#5c666f",
                      "margin-right": "10px"
                    }
                  },
                  [_vm._v("\n                  TOTAL  \n              ")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "fh lc",
                staticStyle: { width: "100%", height: "30%" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "fh lc",
                    staticStyle: {
                      width: "75%",
                      height: "100%",
                      "font-weight": "500",
                      "font-size": "20px",
                      color: "#4969B2",
                      "margin-left": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "\n                  " +
                        _vm._s(_vm.item.CantidadItems) +
                        "  \n              "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "fh rc",
                    staticStyle: {
                      width: "25%",
                      height: "100%",
                      "font-size": "11px",
                      color: "#5c666f",
                      "margin-right": "10px"
                    }
                  },
                  [_vm._v("\n                  ITEMS  \n              ")]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.mobileView
        ? _c(
            "div",
            {
              staticClass: "oblea",
              staticStyle: { width: "140px", height: "90px" },
              on: { click: _vm.btnVer }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fh lc",
                  staticStyle: { width: "100%", height: "25%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lb",
                      staticStyle: {
                        width: "75%",
                        height: "100%",
                        "font-size": "12px",
                        "font-weight": "500",
                        "margin-left": "5px"
                      }
                    },
                    [_vm._v("Dev: " + _vm._s(_vm.item.Numero))]
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh lt",
                  staticStyle: {
                    width: "100%",
                    height: "25%",
                    "font-weight": "400",
                    "font-size": "8px",
                    color: "#5c666f",
                    "margin-left": "5px",
                    "margin-right": "5px"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: { width: "77%", height: "100%" }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("filterFecha")(_vm.item.Fecha)) +
                          " "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: { width: "23%", height: "100%" }
                    },
                    [_c("div", { attrs: { id: "circulo" + _vm.item.Estado } })]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh lc",
                  staticStyle: { width: "100%", height: "25%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        width: "75%",
                        height: "100%",
                        "font-weight": "500",
                        "font-size": "12px",
                        color: "#4969B2",
                        "margin-left": "5px"
                      }
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s(_vm._f("formatMoney")(_vm.item.MontoTotal)) +
                          " \n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh rc",
                      staticStyle: {
                        width: "25%",
                        height: "100%",
                        "font-size": "8px",
                        color: "#5c666f",
                        "margin-left": "5px",
                        "margin-right": "5px"
                      }
                    },
                    [_vm._v("\n            Monto  \n          ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fh lc",
                  staticStyle: { width: "100%", height: "25%" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "fh lc",
                      staticStyle: {
                        width: "75%",
                        height: "100%",
                        "font-weight": "500",
                        "font-size": "12px",
                        color: "#4969B2",
                        "margin-left": "5px"
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.item.CantidadItems) +
                          "  \n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "fh rc",
                      staticStyle: {
                        width: "25%",
                        height: "100%",
                        "font-size": "8px",
                        color: "#5c666f",
                        "margin-right": "5px"
                      }
                    },
                    [_vm._v("\n            Items  \n          ")]
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fh rb",
        staticStyle: { width: "25%", height: "100%", "margin-right": "5px" }
      },
      [
        _c("img", {
          staticStyle: { width: "15px", height: "15px" },
          attrs: { src: "/dist/icon-ver.png" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61a138a9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a138a9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemDevolucionHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-61a138a9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/itemDevolucionHome.vue
// module chunks = 0